import React from 'react';
import del from '../Res/Icon/delete.png';
import edit from '../Res/Icon/edit.png';
import recover from '../Res/Icon/recover.png';
import UserStatus from './UserStatus';
import utils from '../lib/utils';
import { COMPANY_TYPE_DROPDOWN } from '../lib/constants';
import { getPermissionForComponent } from '../utils/permissionsUtils';

const Company = ({
  company,
  disabled,
  onDelete,
  onSetStatus,
  onEdit,
  user,
  deleteMode,
  onRecover,
}) => {
  const {
    _id: id,
    epikCustomerId,
    name,
    companyType,
    enabled,
    creationDate,
    companyGroups,
    managedDevices,
    monitoredDevices
  } = company;

  const canDeleteCompany = getPermissionForComponent('deleteCompany', user.permissionsGroup);

  return (
    <tr>
      {/* <td>{epikCustomerId || '-'}</td> */}
      <td>{epikCustomerId || '-'}</td>
      <td>
        {companyGroups?.map(val => (
          <div>{val?.name || '-'}</div>
        ))}
      </td>
      <td>{name}</td>
      <td>{managedDevices || 0}</td>
      <td>{monitoredDevices || 0}</td>
      <td>{COMPANY_TYPE_DROPDOWN?.filter(item => item.value === companyType)[0]?.label || '-'}</td>
      <UserStatus
        canChange={disabled}
        enabled={enabled}
        onSetStatus={() => {
          onSetStatus(id, !enabled);
        }}
      />
      <td>{utils.getDateTimeFormat(creationDate, 'regular')}</td>
      <td style={{ minWidth: '100px' }}>
        {user.role !== 'companyGroupManager' ? (
          <>
            {!deleteMode ? (
              <img
                onClick={() => {
                  onEdit(company);
                }}
                className="actions-icon"
                src={edit}
                alt="edit"
              />
            ) : (
              <img
                onClick={() => onRecover(id)}
                className="actions-icon"
                src={recover}
                alt="recover"
              />
            )}
            {/* <Button
              color="danger"
              onClick={() => {
                onDelete(id);
              }}
              disabled={disabled}
            >
              Delete
            </Button> */}
            {(canDeleteCompany === 'write' || canDeleteCompany === 'both') && <img
              onClick={() => {
                onDelete(id);
              }}
              disabled={disabled}
              className="actions-icon"
              src={del}
              alt="delete"
            />}
          </>
        ) : null}
      </td>
    </tr>
  );
};

export default Company;
